import { render, staticRenderFns } from "./ArchiveVenueModal.vue?vue&type=template&id=28972e24"
import script from "./ArchiveVenueModal.vue?vue&type=script&lang=js"
export * from "./ArchiveVenueModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports